"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformQuotaFromApi = transformQuotaFromApi;
exports.mapFromPartialQuota = mapFromPartialQuota;
exports.transformQuotaDataForPost = transformQuotaDataForPost;
exports.transformQuotaDataForPut = transformQuotaDataForPut;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _keySeq = _interopRequireDefault(require("transmute/keySeq"));

var _quotaUtils = require("./quotaUtils");

var _QuotaRecord = _interopRequireDefault(require("../records/QuotaRecord"));

var ALLOWED_PUT_VALUES = ['value', 'currency', 'pipelineId'];
var SOURCE = 'API';
var jsToApiKeyMap = {
  quotaType: 'hs_quota_type',
  currency: 'hs_currency',
  period: 'hs_period',
  value: 'hs_value',
  startDate: 'hs_period_start_date',
  endDate: 'hs_period_end_date',
  ownerId: 'hubspot_owner_id',
  pipelineId: 'hs_pipeline_id'
};
var apiToJsKeyMap = (0, _keySeq.default)(jsToApiKeyMap).reduce(function (map, key) {
  var newMap = (0, _extends2.default)({}, map);
  newMap[jsToApiKeyMap[key]] = key;
  return newMap;
}, {});

function transformQuotaFromApi(quota) {
  var props = {};
  (0, _keySeq.default)(quota.properties).filter(function (key) {
    return key in apiToJsKeyMap;
  }).forEach(function (key) {
    props[apiToJsKeyMap[key]] = quota.properties[key].value;
  });
  return new _QuotaRecord.default((0, _extends2.default)({
    id: quota.objectId,
    portalId: quota.portalId
  }, props, {
    startDate: _I18n.default.moment(parseInt(props.startDate, 10)),
    endDate: _I18n.default.moment(parseInt(props.endDate, 10)),
    value: parseInt(props.value, 10),
    ownerId: parseInt(props.ownerId, 10)
  }));
}

function mapFromPartialQuota(quota) {
  return (0, _keySeq.default)(quota.properties).filter(function (key) {
    return key in apiToJsKeyMap;
  }).reduce(function (curProps, key) {
    return curProps.set(apiToJsKeyMap[key], key === jsToApiKeyMap.value ? parseInt(quota.properties[key].value, 10) : quota.properties[key].value);
  }, (0, _immutable.Map)()).set('id', quota.objectId);
}

function transformQuotaDataForPost(quota, timestamp) {
  quota = quota.set('endDate', (0, _quotaUtils.getEndOfPeriod)(quota.period, quota.startDate));
  return {
    object: {
      properties: quota.keySeq().filter(function (jsKey) {
        return jsKey in jsToApiKeyMap;
      }).map(function (jsKey) {
        return {
          name: jsToApiKeyMap[jsKey],
          // if data formatting gets more complicated this should be extracted
          // out into a function that formats based on the current key
          value: _I18n.default.moment.isMoment(quota.get(jsKey)) ? quota.get(jsKey).valueOf() : quota.get(jsKey),
          timestamp: timestamp,
          source: SOURCE
        };
      })
    }
  };
}

function transformQuotaDataForPut(quota, attributesToUpdate, timestamp) {
  return {
    quotaId: quota.id,
    portalId: quota.portalId,
    properties: ALLOWED_PUT_VALUES.filter(function (key) {
      return attributesToUpdate.has(key) && attributesToUpdate.get(key) !== quota.get(key);
    }).map(function (jsKey) {
      return {
        name: jsToApiKeyMap[jsKey],
        value: attributesToUpdate.get(jsKey),
        timestamp: timestamp,
        source: SOURCE
      };
    })
  };
}